const common = {
  siteName: "51吃瓜网",
  siteTagline: "每日吃瓜必吃 · 黑料爆料第一站",
  nav: {
    home: "首页",
    category: "分类",
    aboutUs: "关于我们",
    search: "搜索",
    login: "登录",
  },
  breadcrumb: {
    home: "首页",
    category: "分类",
    article: "文章",
    aboutUs: "关于我们",
  },
  cta: {
    joinTitle: "立即加入吃瓜大军",
    joinSubtitle: "不错过任何一个大瓜，获取第一手爆料资讯",
    joinButton: "立即加入",
    subscribeTitle: "关注51吃瓜网，永不错过大瓜",
    subscribeSubtitle: "每日更新热点瓜闻，正能量不打烊",
    subscribeButton: "订阅我们",
  },
  footer: {
    description: "51吃瓜网——国内领先的娱乐资讯平台，每日更新热点瓜闻、网红爆料、娱乐圈大事，正能量不打烊，吃瓜群众永久入口。",
    contactTitle: "联系我们",
    contactEmail: "hello@9mzg.cn",
    contactPhone: "400-888-5151",
    businessTitle: "商务合作",
    businessEmail: "hello@9mzg.cn",
    reportTitle: "举报邮箱",
    reportEmail: "hello@9mzg.cn",
    address: "北京市朝阳区光华路15号",
    copyright: "© 2026 51吃瓜网 版权所有",
    privacy: "隐私政策",
    terms: "用户协议",
    disclaimer: "免责声明",
    weibo: "微博",
    wechat: "微信",
    douyin: "抖音",
    bilibili: "B站",
  },
  readMore: "阅读全文",
  viewAll: "查看全部",
  loading: "加载中...",
  error: "加载失败，请重试",
};

export default common;